/* eslint-disable max-len */
import React from 'react';
import i18n from 'i18next';

import { Loading } from 'uikit/loaders';

import { addModal, getReportActivityModal, useGlobalQueries } from '@/exceed';

import useSetEnrollmentStatus from '../hooks/useSetEnrollmentStatus';
import useVideo from '../hooks/useVideo';

import getIsUserPublic from '../helpers/getIsUserPublic';

import Video from '../components/video';

import styles from '../styles/videoContainer.module.scss';

export default () => {
  const {
    video,
    selectedAgendaItem,
    relatedVideos,
    relatedCourses,
    handlers,
    screenSize,
    agendaItems,
    isLoading,
    isVideoFetching,
  } = useVideo();

  const { currentUser } = useGlobalQueries();

  const {
    favouriteVideo,
    unfavouriteVideo,
    createEnrollment,
    updateEnrollment,
    updateReview,
    viewAgendaItem,
    refetchAgendaItems,
  } = handlers;

  const { isSettingEnrollmentStatus, setEnrollmentStatus } = useSetEnrollmentStatus({
    isVideoFetching,
    refetchAgendaItems,
  });

  const showLoginDialog = () => {
    const modal = document.getElementById('public-login-dialog');

    modal.dispatchEvent(
      new CustomEvent('show.dialog', {
        detail: { url: '/student/authentication/public_modal' },
      }),
    );
  };

  const dropEnrollment = async () => {
    if (getIsUserPublic({ currentUser })) return showLoginDialog();

    const modal = await addModal({
      actions: [
        { action: 'cancel', text: i18n.t('cancel'), variant: 'ghost' },
        { action: 'submit', text: i18n.t('confirm-drop'), color: 'negative' },
      ],
      body: i18n.t('drop-enrollment-body'),
      title: i18n.t('drop-enrollment'),
    });

    if (modal.type !== 'submit') return;

    setEnrollmentStatus('drop');
  };

  return isLoading ? (
    <Loading className={styles.loader} />
  ) : (
    <Video
      video={video}
      screenSize={screenSize}
      relatedVideos={relatedVideos}
      relatedCourses={relatedCourses}
      favouriteVideo={favouriteVideo}
      unfavouriteVideo={unfavouriteVideo}
      dropEnrollment={dropEnrollment}
      reportVideo={getReportActivityModal}
      createEnrollment={createEnrollment}
      updateEnrollment={updateEnrollment}
      updateReview={updateReview}
      agendaItems={agendaItems}
      selectedAgendaItem={selectedAgendaItem}
      viewAgendaItem={viewAgendaItem}
      isSettingEnrollmentStatus={isSettingEnrollmentStatus}
      setEnrollmentStatus={setEnrollmentStatus}
    />
  );
};
